import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { CacaoArtSection } from '../components/CacaoArtSection';
import { PromoBanner } from '../components/PromoBanner';
import { StorySection } from '../components/StorySection';
import { ProductsSection } from '../components/ProductsSection';
import { IngredientsSection } from '../components/IngredientsSection';
import { GiftCardSection } from '../components/GiftCardSection';
import { OrderInfoSection } from '../components/OrderInfoSection';
export function Home() {
  return <>
      <HeroSection data-id="element-380" data-mp="24hag5mold6dk" />
      <CacaoArtSection data-id="element-381" data-mp="24ivabb6zunaw" />
      <PromoBanner data-id="element-382" data-mp="29flsc42czsyy" />
      <StorySection data-id="element-383" data-mp="29f26wddi2mg6" />
      <ProductsSection data-id="element-384" data-mp="29ek5z3fw7k1x" />
      <IngredientsSection data-id="element-385" data-mp="29ihq9se7ihne" />
      <GiftCardSection data-id="element-386" data-mp="2di8cdissg9ll" />
      <OrderInfoSection data-id="element-387" data-mp="2dirxt9hndg4d" />
    </>;
}